<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`油气费汇总表`)">导出</el-button>
        </el-form-item>

        <!-- 全部记录 -->
        <el-form-item>
          <el-button class="allRecord" type="primary"
            @click="goAllRecord">全部记录</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'oil',
      getListUrl: 'summarylist',
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.fleet,
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "gasname", label: "油气站名称" },
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "doil_count", label: "加油单量", align: 'right', className: 'pr30' },
        { keyName: "doil", label: "现金加油金额", align: 'right', className: 'pr30' },
        { keyName: "moneydoil", label: "非现金加油金额", align: 'right', className: 'pr30' },
        { keyName: "summary_doil", label: "加油金额合计", align: 'right', className: 'pr30' },
      ],
      getTotalProperty: [
        'doil_count',
        'doil',
        'moneydoil',
        'summary_doil'
      ],
      btns: [
        {
          class: 'viewlistbtn',
          title: '查看列表',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push({
              path: `/finance/oilFee/siteorder`,
              query: {
                license,
                month,
                gsid: this.$route.query.gsid,
              }
            })
          },
        },
      ],
      baseParams: [
        'gsid',
        'month',
      ],
    };
  },
  methods: {
    goAllRecord() {
      this.$router.push({
        path: `/finance/oilFee/siteorderall`,
        query: {
          month: this.formInline.month,
          gsid: this.formInline.gsid,
        }
      })
    },
  },
  mounted() {
    this.getFleet()
    this.setQueryParams()
    this.MONTH = this.$route.query.month || this.CURR_MONTH
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped></style>
